<template>
  <div id="search-input" :style="'width: ' + width">
    <input type="text" v-model="data" :style="inputStyle" :placeholder="placeholder" @input="onInput" />
    <div id="list" v-if="list && list.length > 0">
      <ul>
        <li v-for="(value, index) in list" :key="index" @click="data=value">{{value}}</li>
      </ul>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'
export default {
  name: 'search-input',
  components: {},
  props: [
    'defaultFilter',
    'placeholder',
    'inputStyle',
    'readField',
    'basePath',
    'initData',
    'filter',
    'width'
  ],
  created () {
    this.$emit('loading')
    this.debouncedGetAnswer = _.debounce(this.listData, 450)
  },
  watch: {
    data () {
      this.$emit('data', this.data)
    },
    initData () {
      if (this.initData !== this.data) this.data = this.initData
    }
  },
  data () {
    return {
      data: '',
      list: []
    }
  },
  methods: {
    ...mapActions({
      getList: 'listes/list'
    }),
    listData () {
      this.getList({path: this.basePath, filters: Object.assign({[this.filter]: this.data}, this.defaultFilter)}).then(response => {
        this.list = response.list
      })
    },
    onInput () {
      this.data = this.data.toUpperCase()
      this.debouncedGetAnswer()
    }
  }
}
</script>

<style scoped lang="scss">
#search-input{
    position: relative;
}
input{
    width: 100%;
}
input:focus + #list{
    visibility: visible;
    opacity: 1;
}
#list{
    visibility: hidden;
    opacity: 0;
    transition: visibility 0.2s, opacity 0.2s ease-out;
    position: absolute;
    width: 100%;
    border: 2px solid #CCCCCC;
    border-bottom-left-radius: .6em;
    border-bottom-right-radius: .6em;
    overflow: auto;
    padding: .4em;
    max-height: 10em;
    background: white;
    box-sizing: border-box;
    z-index: 99999;
}
ul{
    list-style: none;
}
li{
    padding: .3em;
    border-radius: .4em;
    transition: all 0.1s;
    cursor: pointer;
    &:hover{
        background: #C9D70A;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/SearchInput.vue